module.exports = __webpack_public_path__ + "img/image 1.abf03339.png";